import { render, staticRenderFns } from "./table-no-page.vue?vue&type=template&id=4adce6c0&scoped=true&"
import script from "./table-no-page.vue?vue&type=script&lang=js&"
export * from "./table-no-page.vue?vue&type=script&lang=js&"
import style0 from "./table-no-page.vue?vue&type=style&index=0&id=4adce6c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adce6c0",
  null
  
)

export default component.exports